import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  hide() {
    this.bannerTarget.classList.add("opacity-0")

    this.bannerTarget.addEventListener("transitionend", () => {
      this.bannerTarget.classList.add("hidden")
    }, { once: true })
  }
}
